import { createSlice } from "@reduxjs/toolkit";
import { ActionType } from "../actionTypes";
import { App, AppUser, UserRole } from "../types/app";
import { SettingsMap } from "../types/setting";
import { Setting } from "../types/setting";

export interface SettingsState {
  settingsMap: SettingsMap;
  roles: UserRole[];
  apps: App[];
  appsLoaded: boolean;
  allWorkspaces: App[];
  workspaceUsers: AppUser[];
  allUsers: AppUser[];
  appOwner?: string;
  // The Account's Home Workspace: the Home Record's "app-id" (system:#home; query-omega-oql pages/oql/terms.html).
  // undefined until the Home read answers, or when the Record names none (an account with no listable app).
  homeApp?: string;
}

const initialState: SettingsState = {
  settingsMap: {},
  roles: [],
  apps: [],
  appsLoaded: false,
  allWorkspaces: [],
  workspaceUsers: [],
  allUsers: [],
  appOwner: undefined,
  homeApp: undefined,
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // ADD_SETTINGS — merges settings into the settingsMap
    builder.addCase(ActionType.ADD_SETTINGS, (state, action: any) => {
      const settings: Setting[] = action.settings;
      const actionSettingsMap = Object.fromEntries(
        settings.map((setting) => [setting.key, setting]),
      );
      return {
        ...state,
        settingsMap: { ...state.settingsMap, ...actionSettingsMap },
      };
    });

    // SET_ROLES
    builder.addCase(ActionType.SET_ROLES, (state, action: any) => {
      return { ...state, roles: action.roles };
    });

    // SET_APPS
    builder.addCase(ActionType.SET_APPS, (state, action: any) => {
      return { ...state, apps: action.apps, appsLoaded: true };
    });

    // SET_ALL_WORKSPACES
    builder.addCase(ActionType.SET_ALL_WORKSPACES, (state, action: any) => {
      return { ...state, allWorkspaces: action.allWorkspaces };
    });

    // SET_WORKSPACE_USERS
    builder.addCase(ActionType.SET_WORKSPACE_USERS, (state, action: any) => {
      return { ...state, workspaceUsers: action.workspaceUsers };
    });

    // SET_ALL_USERS
    builder.addCase(ActionType.SET_ALL_USERS, (state, action: any) => {
      return { ...state, allUsers: action.allUsers };
    });

    // SET_APP_OWNER
    builder.addCase(ActionType.SET_APP_OWNER, (state, action: any) => {
      return { ...state, appOwner: action.appOwner };
    });

    // SET_HOME_APP
    builder.addCase(ActionType.SET_HOME_APP, (state, action: any) => {
      return { ...state, homeApp: action.homeApp };
    });
  },
});

export default settingsSlice.reducer;
